import React from "react";
import { render } from "react-dom";
import { InertiaApp } from "@inertiajs/inertia-react";
import * as Sentry from "@sentry/browser";
// import { Inertia } from "@inertiajs/inertia";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

Sentry.init({
	dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
});

// Inertia.on("navigate", (event) => {
// 	// console.log(`Navigated to page: ${event.detail.page.url}`);
// 	gtag("event", "page_view", {
// 		page_location: event.detail.page.url,
// 	});
// });

const app = document.getElementById("app");

render(<InertiaApp initialPage={JSON.parse(app.dataset.page)} resolveComponent={(name) => import(`./Pages/${name}`).then((module) => module.default)} />, app);
